<div [class]="isCdkDialog ? 'tw:mx-auto tw:w-screen tw:max-w-3xl tw:overflow-hidden tw:rounded-lg tw:bg-white tw:shadow-lg' : ''">
<!-- HEADER -->
<div class="tw:bg-primary-50 tw:p-4 tw:md:p-8 tw:flex tw:justify-between tw:items-center tw:gap-4">
    <div class="tw:flex tw:justify-between tw:items-center tw:w-full">
        <div>
            <div class="tw:flex tw:items-center tw:gap-2">
                <h3 class="tw:h3">{{ 'SALE_DETAILS.headerTitle' | translate }} {{ sale.invoiceReference || sale.code }}</h3>
                <div class="tw:block tw:md:hidden">
                    <app-sales-status [sale]="sale" />
                </div>
            </div>
            <p class="text-small text-secondary mb-0">{{ 'SALE_DETAILS.registeredBy' | translate }} {{ sale.createdByUser?.name }} {{ sale.createdAt | date: 'dd/MM/yyyy' }} {{ sale.createdAt | date: 'HH:mm' }}</p>
        </div>
        <div class="tw:hidden tw:md:block">
            <app-sales-status [sale]="sale" />
        </div>
    </div>

    <i class="material-icons ico-close clickable mb-1" (click)="close()">close</i>
</div>

<!-- BODY -->
@if (loadingSaleDetails()) {
    <div class="tw:p-8">
        <app-loader />
    </div>
} @else {
    <div class="tw:px-8 tw:py-2 tw:md:py-4 tw:grid tw:md:grid-cols-2 tw:gap-4">
        <!-- PREVIEW  -->
        <div>
            @if (seeInvoicePreview()) {
                <app-invoice-preview [fixedSaleData]="sale" [showEditPaymentButton]="true" [showSendPaymentLinkButton]="false" />
            }
            <!-- <app-invoice-preview [fixedSaleData]="sale" [showEditPaymentButton]="true" [showSendPaymentLinkButton]="true" (sendPaymentLinkClicked)="sendPaymentLink()"></app-invoice-preview> -->
        </div>

        <div>
            <!-- CLIENT DETAILS -->
            <div class="tw:mb-6 tw:flex tw:items-center tw:justify-between tw:rounded-lg tw:bg-primary-50 tw:p-4">
                <app-icon icon="person" extraClass="tw:!text-primary-500" />
                <div class="tw:ml-4 tw:flex-1">
                    @if (sale.clientName) {
                        <div class="tw:font-bold tw:text-primary-500">{{ sale.clientName }}</div>
                    } @else if (!sale.clientVatNumber) {
                        <div class="tw:font-bold tw:italic tw:text-neutral-400">{{ 'GENERAL.walkInCustomer' | translate }}</div>
                    }
                    @if (sale.clientVatNumber) {
                        <div class="tw:text-sm tw:text-neutral-500">{{ 'DASHBOARD.clientForm.vatNumber' | translate }} {{ sale.clientVatNumber }}</div>
                    } @else if (sale.clientName) {
                        <div class="tw:font-bold tw:italic tw:text-neutral-400">{{ 'GENERAL.walkInCustomer' | translate }}</div>
                    }
                </div>
            </div>

            <app-sale-detail-documents [sale]="sale" />
            
            <!-- ACTIONS -->
            <app-sale-detail-actions (saleUpdated)="saleUpdated()" (closeParent)="close()" (destroyPreview)="destroyPreview()" [sale]="sale" />

        </div>


    </div>
}
</div>
